import { createApiCallActions } from '../../../common/store/generic.actions';
import { MediumModel } from './types';
import { ListItem } from '../typeahead/types';

export const mediumActions = {
  getById: createApiCallActions<MediumModel>('medium', 'getById'),
  getList: createApiCallActions<ListItem[]>('medium', 'getList'),
  add: createApiCallActions<MediumModel>('medium', 'add'),
  update: createApiCallActions<MediumModel>('medium', 'update'),
};

export type MediumAction = typeof mediumActions;
